import React from 'react';
import c from 'classnames';
import Immutable from 'immutable';

import { ImageFromField } from '@uncinc/react-drupal-core';

import './style.scss';
import {
  SCREEN_MOBILE,
  SCREEN_NORMAL,
  SCREEN_TABLET,
  SCREEN_WIDE,
} from '../../../../config/constants';

export interface WebformQuizRadiosWithImageImageProps {
  title?: string;
  alt: string;
  className?: string;
  src: string;
  styles: Record<string, string>;
}

const WebformQuizRadiosWithImageImage: React.FC<WebformQuizRadiosWithImageImageProps> = ({
  title,
  alt,
  className,
  src,
  styles,
}) => (
  <div className={c('WebformQuizRadiosWithImageImage', className)}>
    <ImageFromField
      className="WebformQuizRadiosWithImageImage__image"
      src={src}
      field={Immutable.fromJS({ title, alt, styles })}
      imageStyles={Immutable.Map({
        [SCREEN_MOBILE]: 'quiz_radios_with_image_mobile',
        [SCREEN_TABLET]: 'quiz_radios_with_image_tablet',
        [SCREEN_NORMAL]: 'quiz_radios_with_image_desktop',
        [SCREEN_WIDE]: 'quiz_radios_with_image_desktop',
      })}
      // Lazy loading seems to break here.
      includeWebP={false}
    />
  </div>
);

export default WebformQuizRadiosWithImageImage;
